const showSpinner = ({ commit }, bool) => {
    commit('SHOW_SPINNER', bool)
}

const resetState = function({ commit }) {
    commit('RESET_STATE')
}

export default {
    resetState,
    showSpinner,
}
